import { SvgIcon, SvgIconProps} from '@mui/material';
import './ccf-call-outbound-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfCallOutboundIconProps extends SvgIconProps {}

/**
 * this component will retunr ccf call outbound icon
 * @param props -CcfCallOutboundIconProps
 * @example
 * @returns
 */
export function CcfCallOutboundIcon(props: CcfCallOutboundIconProps) {
  return (
    <SvgIcon {...props} width="13.067" height="14" viewBox="0 0 13.067 14">
      <g id="phone-outbound">
        <path
          id="Path_12422"
          data-name="Path 12422"
          d="M7.834-33.453s-.563.909-.615.986-.161.306-.685.151a7.607,7.607,0,0,1-3.1-2.239,7.9,7.9,0,0,1-2.167-3.207c-.15-.541.071-.654.146-.708s.955-.635.955-.635c.592-.359-.077-1.893-1.158-2.631-.8-.545-1.147-.492-1.482-.224a8.627,8.627,0,0,0-1.454,1.54,1.5,1.5,0,0,0-.254,1.051,8.973,8.973,0,0,0,1.188,3.3,15.813,15.813,0,0,0,2.5,3.29,15.5,15.5,0,0,0,3.184,2.586,8.322,8.322,0,0,0,3.2,1.228,1.386,1.386,0,0,0,1.017-.263,8.608,8.608,0,0,0,1.49-1.5c.26-.346.311-.707-.217-1.531C9.667-33.373,8.182-34.065,7.834-33.453Z"
          transform="translate(2 42.944)"
        />
        <path
          id="Path_12423"
          data-name="Path 12423"
          d="M1.172,6,3.788,3.3,4.82,4.363c.179.183.365.126.416-.129L6,.377C6.048.124,5.889-.044,5.642.01L1.91.8c-.247.053-.3.245-.125.43L2.816,2.292.2,5a.728.728,0,0,0,0,1A.674.674,0,0,0,1.172,6Z"
          transform="translate(7.059 0)"
        />
      </g>
    </SvgIcon>
  );
}

export default CcfCallOutboundIcon;
